import type { IBuild } from '@/entities/build.entity';
import { cn } from '@/lib/utils';
import { BanIcon, CheckCircleIcon, ClockIcon, LoaderIcon, XCircleIcon } from 'lucide-react';

function getBuildStatus(build: IBuild) {
	if (build.cancelled) {
		return { label: 'Отменён', icon: BanIcon, className: 'text-muted-foreground', pulse: false };
	}
	if (build.isBuilding) {
		return { label: 'Собирается', icon: LoaderIcon, className: 'text-chart-5', pulse: true };
	}
	if (build.inQueue) {
		return { label: 'В очереди', icon: ClockIcon, className: 'text-muted-foreground', pulse: true };
	}
	if (build.successBuilded) {
		return { label: 'Готов', icon: CheckCircleIcon, className: 'text-chart-2', pulse: false };
	}
	return { label: 'Ошибка', icon: XCircleIcon, className: 'text-destructive', pulse: false };
}

interface BuildStatusBadgeProps {
	build: IBuild;
	className?: string;
}

export default function BuildStatusBadge({ build, className }: BuildStatusBadgeProps) {
	const status = getBuildStatus(build);
	const StatusIcon = status.icon;

	return (
		<span
			className={cn(
				'inline-flex items-center gap-1 rounded-full border border-border bg-background/80 px-2 py-0.5 text-xs font-medium',
				status.className,
				status.pulse && 'animate-pulse',
				className,
			)}
		>
			<StatusIcon size={12} className={status.pulse ? 'animate-spin' : undefined} />
			{status.label}
		</span>
	);
}
